import { render, staticRenderFns } from "./Asterisk.vue?vue&type=template&id=bdcf1430&scoped=true"
import script from "./Asterisk.vue?vue&type=script&lang=js"
export * from "./Asterisk.vue?vue&type=script&lang=js"
import style0 from "./Asterisk.vue?vue&type=style&index=0&id=bdcf1430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcf1430",
  null
  
)

export default component.exports